import groupBy from 'lodash/groupBy';

export function getParticipantsByTeam(state) {
  return groupBy(state.participant.participants, 'teamId');
}
